module.exports = __webpack_public_path__ + "static/media/uplaod_diamond_demo_file.51fdf905.xlsx";